import React, { useEffect, useState, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
import { SurveyModal } from './components/ui/SurveyModal';
import { SurveyModalContext } from './hooks/use-survey-modal';
export function App() {
  const [isOpen, setIsOpen] = useState(false);
  // Facebook Meta Pixel — guarded against StrictMode double-fire
  useEffect(() => {
    const w = window as any;
    if (w.fbq) return;
    // Bootstrap fbq queue before script loads
    const fbq = function (...args: any[]) {
      fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
    } as any;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [] as any[];
    w.fbq = fbq;
    if (!w._fbq) w._fbq = fbq;
    // Load fbevents.js
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.id = 'fb-pixel-script';
    document.head.appendChild(script);
    // Init + PageView
    w.fbq('init', '878753891400350');
    w.fbq('track', 'PageView');
    // Noscript fallback
    const img = document.createElement('img');
    img.height = 1 as any;
    img.width = 1 as any;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=878753891400350&ev=PageView&noscript=1';
    document.body.appendChild(img);
    // Domain verification meta tag
    if (!document.querySelector('meta[name="facebook-domain-verification"]')) {
      const meta = document.createElement('meta');
      meta.name = 'facebook-domain-verification';
      meta.content = 'vyjg7axggtm2tebjcaln8f66ngrgpn';
      document.head.appendChild(meta);
    }
  }, []);
  // Load HeatSnap tracker script
  useEffect(() => {
    if (document.getElementById('heatsnap-tracker')) return;
    const script = document.createElement('script');
    script.src = 'https://heatmapsaas-zbdj9rd8.manus.space/tracker.js';
    script.setAttribute('data-token', '4Ppug-KAJulyX77l4t-JrEuaVOAISeDg');
    script.async = true;
    script.id = 'heatsnap-tracker';
    document.body.appendChild(script);
  }, []);
  return <SurveyModalContext.Provider value={{
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false)
  }} data-id="element-0">
      <LandingPage data-id="element-1" />
      <SurveyModal data-id="element-2" />
    </SurveyModalContext.Provider>;
}